export const TimezonesKey = 'timezones';